import { OrderType, inferLiteral } from "client/utils"
import {
    SilSafetyFunction,
    SilSubsystem,
} from "server/models"
import * as types from "./types"


export const setSilSafetyFunctionBaseRoute = (baseRoute: string) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_BASE_ROUTE),
    baseRoute,
})


export const setSilSafetyFunctionList = (safetyFunctionList: types.SilSafetyFunctionList) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_LIST),
    safetyFunctionList,
})
export const setSilSafetyFunctionIds = (safetyFunctionIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_IDS),
    safetyFunctionIds,
})
export const setSilSafetyFunctionView = (safetyFunction: SilSafetyFunction) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_VIEW),
    safetyFunction,
})
export const setSilSafetyFunctionEdit = (safetyFunction: SilSafetyFunction) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_EDIT),
    safetyFunction,
})


export const setSilSafetyFunctionSubsystemList = (subsystemList: readonly SilSubsystem[]) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_SUBSYSTEM_LIST),
    subsystemList,
})


export const setSilSafetyFunctionSort = (sortColumn: keyof SilSafetyFunction, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_SORT),
    sortColumn,
    sortOrder,
})
export const setSilSafetyFunctionFilters = (filters: types.SilSafetyFunctionFilters) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_FILTERS),
    filters,
})


export const setSilSafetyFunctionReloadList = (value: boolean) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_RELOAD_LIST),
    value,
})
export const setSilSafetyFunctionReloadView = (value: boolean) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_RELOAD_VIEW),
    value,
})
export const setSilSafetyFunctionReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.SIL_SAFETY_FUNCTION_RELOAD_EDIT),
    value,
})
